export const state = {
    sortingDef: [],
    sortingModel: [],
    appliedAt: null,
    sortingModelIsDirty: false
};

export const reducer = {
    setSortingDef(state, action) {
        if ('sortingDef' in (state || {})) {
            state.sortingDef = action?.payload;
        }
    },
    setSortingModelIsDirty(state, action) {
        if ('sortingModelIsDirty' in (state || {})) {
            state.sortingModelIsDirty = Boolean(action?.payload);
        }
    },
    setSorting(state, action) {
        if ('sortingModel' in (state || {})) {
            state.sortingModel = action?.payload;
        }
        if ('appliedAt' in (state || {})) {
            state.appliedAt = new Date();
        }
    },
    clearSorting(state) {
        if ('sortingModel' in (state || {})) {
            state.sortingModel = [];
        }
        if ('sortingModelIsDirty' in (state || {})) {
            state.sortingModelIsDirty = false;
        }
    }
};
